import { Toaster } from "react-hot-toast";

export const ToasterProvider = () => {
  return (
    <div className="sticky top-0 z-50 max-w-page mx-auto">
      <Toaster position="top-right" containerStyle={{ position: "absolute" }} />
    </div>
  );
};
